<template>
  <b-row>
    <!-- Type -->
    <b-col sm="6" lg="4">
      <b-form-group>
        <div class="d-flex form-group-label">
          <label for="type">{{ t('Type') }}</label>
          <span class="text-danger">*</span>
        </div>
        <validation-provider #default="{ errors }" :name="t('Type')" rules="required">
          <b-form-select
            v-model="values.type"
            :options="customerTypes"
            :disabled="type === 'edit'"
            :state="errors.length > 0 ? false : null"
            :placeholder="t('Type')"
            tabindex="3"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>

    <!-- Name -->
    <b-col sm="6" lg="4">
      <b-form-group>
        <div class="d-flex form-group-label">
          <label for="name">{{ t('Name') }}</label>
          <span class="text-danger">*</span>
        </div>
        <validation-provider #default="{ errors }" :name="t('Name')" rules="required">
          <b-form-input
            id="name"
            v-model="values.name"
            name="name"
            :state="errors.length > 0 ? false : null"
            :placeholder="t('Name')"
            tabindex="3"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>

    <!-- Authorized Name Surname -->
    <b-col sm="6" lg="4">
      <b-form-group>
        <div class="d-flex form-group-label">
          <label for="authorized_name_surname">{{ t('Authorized Name Surname') }}</label>
          <span class="text-danger">*</span>
        </div>
        <validation-provider
          #default="{ errors }"
          :name="t('Authorized Name Surname')"
          rules="required"
        >
          <b-form-input
            id="authorized_name_surname"
            v-model="values.authorizedName"
            name="authorized_name_surname"
            :state="errors.length > 0 ? false : null"
            :placeholder="t('Authorized Name Surname')"
            tabindex="3"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>

    <!-- Phone -->
    <b-col sm="6" lg="4">
      <b-form-group>
        <div class="d-flex form-group-label">
          <label for="phone">{{ t('Phone') }}</label>
          <span class="text-danger">*</span>
        </div>
        <validation-provider #default="{ errors }" :name="t('Phone')" rules="required">
          <b-form-input
            id="phone"
            v-model="values.phone"
            name="phone"
            :state="errors.length > 0 ? false : null"
            :placeholder="t('Phone')"
            tabindex="3"
            type="number"
            :readonly="type === 'edit'"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>

    <!-- Package -->
    <b-col sm="6" lg="4">
      <b-form-group>
        <div class="d-flex form-group-label">
          <label for="package_id">{{ t('Package') }}</label>
          <span class="text-danger">*</span>
        </div>
        <validation-provider #default="{ errors }" :name="t('Package')" rules="required">
          <b-form-select
            id="package_id"
            v-model="values.package_id"
            :state="errors.length > 0 ? false : null"
            :options="[{ text: t('Make a Choice'), value: '' }].concat(packageOptions)"
            tabindex="3"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>

    <!-- Payment Type -->
    <b-col sm="6" lg="4">
      <b-form-group>
        <div class="d-flex form-group-label">
          <label for="paymentType">{{ t('Payment Type') }}</label>
          <span class="text-danger">*</span>
        </div>
        <validation-provider #default="{ errors }" :name="t('Payment Type')" rules="required">
          <b-form-select
            v-model="values.paymentType"
            :options="customerPaymentTypeOptions"
            :state="errors.length > 0 ? false : null"
            :placeholder="t('Payment Type')"
            tabindex="3"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>

    <!-- Status -->
    <b-col sm="6" lg="4">
      <b-form-group>
        <div class="d-flex form-group-label">
          <label for="paymentType">{{ t('Status') }}</label>
          <span class="text-danger">*</span>
        </div>
        <validation-provider #default="{ errors }" :name="t('Status')" rules="required">
          <b-form-select
            v-model="values.status"
            :options="customerStatusTypes"
            :state="errors.length > 0 ? false : null"
            :placeholder="t('Status')"
            tabindex="3"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import { BCol, BRow, BFormGroup, BFormInput, BFormSelect } from 'bootstrap-vue';
import { ValidationProvider } from 'vee-validate';
import { useUtils as useI18nUtils } from '@core/libs/i18n';

export default {
  name: 'CustomerAccountForm',
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormSelect,
    ValidationProvider
  },
  props: {
    type: {
      type: String,
      default: 'new'
    },
    values: {
      type: Object,
      required: true
    },
    customerTypes: {
      type: Array,
      default: () => []
    },
    customerPaymentTypeOptions: {
      type: Array,
      default: () => []
    },
    packageOptions: {
      type: Array,
      default: () => []
    },
    customerStatusTypes: {
      type: Array,
      default: () => []
    }
  },
  setup() {
    const { t } = useI18nUtils();
    return { t };
  }
};
</script>
